import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function SubEquipment(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            id="esp_SubEquipment"
            value={props.selectedSubEquipmentName == null ? "" : props.selectedSubEquipmentName}
            onChange={(_event, newValue) => {
                props.handleSubEquipmentChange(newValue);
            }}
            options={props.subEquipmentData.map((option) => option.name)}
            renderInput={(params) => <TextField {...params} margin="normal" label={t("SubEquipment")} variant="outlined" />}
        />
    );
}
